<a class="hidden-link" tabindex="0" href="javascript:;" (click)="redirectTo()" translate="">lbl_skip_main_content_accessibility</a>
<div class="company-logo">
  <img src="/assets/images/temp/nbx_header_logo.svg" height="52px" alt="logo">
</div>
<div class="pt-2" style="height: calc(100vh - 92px); overflow-x: auto;">
<p-panelMenu class="sidebar-panel-menu" [model]="items" [multiple]="false"></p-panelMenu>
@if (displayVersion) {
  <div class="version-section-in-sidebar" [title]="displayVersion">
    Version {{displayVersion}}
  </div>
}
<div class="powered-by-section">
  <div class="col-12 wrapper">
    <div class="text-center">
      <a target="c" href="https://mobisoftinfotech.com/solutions/event-transportation-management-app">
        <img [src]="poweredByLogo">
      </a>
    </div>
  </div>
</div>
</div>


<p-dialog modal="true" [header]="'label_update_available' | translate" class="drop-points-dialog" [closable]="false" position="center" ng-style="overflow: auto" styleClass="add-routes-popup estimation"
  [(visible)]="isUpdateAvailable" [contentStyle]="{'overflow':'auto', 'padding-top': '0px'}" [style]="{width: '500px'}">
  <div class="col-12">
    <p> <strong translate>label_new_update_is_available</strong> </p>
    <p> <strong>Current Version: </strong> {{ currentVersion }} </p>
    <p> <strong>  New Version: </strong> {{ newVersion }} </p>
    <div class="whats-new" [innerHTML]="whatsNew"></div>
  </div>
  <div class="ok-button mt-4" style="text-align:right;">
    <button  [label]="'label_update' | translate" class="plus-button pr-3 pl-3"
      pButton type="button" (click)="updateNow()"></button>

  @if (updateType !== 'MANDATORY') {
      <button [label]="'label_cancel' | translate" class="ml-3 negative-button plus-button"
      pButton type="button" (click)="updateSkipNow()"></button>
    }
  </div>
</p-dialog>